const DEFAULT_FLOW_UPSELL_URL = 'https://otto.vet/inform-otto-family';

/**
 * Marketing destination for the Otto Flow upsell.
 *
 * Read at call time rather than module scope so a value set after import is
 * still picked up. Guarded because `import.meta` is unavailable under some
 * consumers' module systems (e.g. Jest's CommonJS transform).
 */
export function getFlowUpsellUrl(): string {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const meta = import.meta as any;
    return meta.env?.VITE_FLOW_UPSELL_URL || DEFAULT_FLOW_UPSELL_URL;
  } catch {
    return DEFAULT_FLOW_UPSELL_URL;
  }
}
